import { errorPagesConfigs } from "./errorPages";
import { authRouteConfig } from "./auth";
import { initialUrl } from "../shared/constants/AppConst";
import Error403 from "./errorPages/Error403";
import React from "react";
import TermsOfService from "./legal/TermsOfService";
import PrivacyPolicy from "./legal/PrivacyPolicy";
import Error404 from "./errorPages/Error404";
import ActionNeededTreatments from "./treatments/action-needed";
import ArchivedTreatments from "./treatments/archived";
import ViewOnGoingTreatments from "./treatments/on-going";
import CreateUpdate from "./price-brackets/create-update";
import PriceBracketsList from "./price-brackets";

const Companies = React.lazy(() => import("./companies"));
const CreateOrUpdateCompany = React.lazy(
  () => import("./companies/create-or-update"),
);

// Agent Companies
const AgentCompanies = React.lazy(() => import("./agent-companies"));
const CreateOrUpdateAgentCompany = React.lazy(
  () => import("./agent-companies/create-or-update"),
);
const AgentCompanyDetails = React.lazy(
  () => import("./agent-companies/details"),
);

// Roles Management
const RolesManagement = React.lazy(() => import("./roles-management"));
const CreateOrUpdateRole = React.lazy(
  () => import("./roles-management/create-or-update"),
);
const RoleDetails = React.lazy(() => import("./roles-management/role-details"));

// Users Management
const UsersManagement = React.lazy(() => import("./users-management"));
const UserDetails = React.lazy(() => import("./users-management/user-details"));
const CreateOrUpdateUser = React.lazy(
  () => import("./users-management/create-or-update"),
);
const UpdateUserPermissions = React.lazy(
  () => import("./users-management/update-user-permissions"),
);

// Questions  Management
const QuestionsManagement = React.lazy(() => import("./questions-management"));
const CreateOrUpdateQuestion = React.lazy(
  () => import("./questions-management/create-or-update"),
);
const QuestionDetails = React.lazy(
  () => import("./questions-management/question-details"),
);

// Clients Management
const ClientsManagement = React.lazy(() => import("./clients-management"));
const ClientDetails = React.lazy(
  () => import("./clients-management/client-details"),
);
// Patients
const PatientManagement = React.lazy(() => import("./patients"));

// Packages
const Packages = React.lazy(() => import("./packages"));
const CreateOrUpdatePackage = React.lazy(
  () => import("./packages/create-or-update"),
);

// Treatments
const TreatmentManagement = React.lazy(() => import("./treatments"));
const TreatmentDetails = React.lazy(() => import("./treatments/details"));
const PlanDetails = React.lazy(() => import("./treatments/plan-details"));
const SubmitPlan = React.lazy(() => import("./treatments/submit-plan"));

// Case Pricing
const CasePricing = React.lazy(() => import("./case-pricing"));
const CreateOrUpdateCasePricing = React.lazy(
  () => import("./case-pricing/create-or-update"),
);
// Case Treatment Material
const CaseTreatmentMaterial = React.lazy(() => import("./case-material"));
const CreateOrUpdateCaseTreatmentMaterial = React.lazy(
  () => import("./case-material/create-or-update"),
);
//Colors
const TreatmentColors = React.lazy(() => import("./treatment-colors"));
const CreateOrUpdateTreatmentColors = React.lazy(
  () => import("./treatment-colors/create-or-update"),
);
// Treatment types
const TreatmentTypes = React.lazy(() => import("./treatment-types"));
const CreateOrUpdateTreatmentTypes = React.lazy(
  () => import("./treatment-types/create-or-update"),
);
// Cases
const CaseManagement = React.lazy(() => import("./cases"));
const ActionNeededCases = React.lazy(() => import("./cases/action-needed"));
const OnGoingCases = React.lazy(() => import("./cases/on-going"));
const CaseDetails = React.lazy(() => import("./cases/details"));
// const PlanCaseDetails = React.lazy(() => import('./treatments/plan-details'));

// promo codes
const PromoCodes = React.lazy(() => import("./promo-codes"));
const CreateOrUpdatePromoCode = React.lazy(
  () => import("./promo-codes/create-or-update"),
);

// My Profile
const MyProfile = React.lazy(() => import("./my-profile"));

// Agent Company Dashboard
const AgentCompanyDashboard = React.lazy(() => import("./agent-company-dashboard"));

// Cash Payment Report
const CashPaymentReport = React.lazy(() => import("./cash-payment-report"));

// Planner Statistics
const PlannerStatistics = React.lazy(() => import("./planner-statistics"));

// Fabricator Statistics
const FabricatorStatistics = React.lazy(() => import("./fabricator-statistics"));

// Coordinator Statistics
const CoordinatorStatistics = React.lazy(() => import("./coordinator-statistics"));

// Agent Company Statistics
const AgentCompanyStatistics = React.lazy(() => import("./agent-company-statistics"));

const authorizedStructure = {
  fallbackPath: "/sign-in",
  unAuthorizedComponent: <Error403 />,
  routes: [
    {
      path: "/companies",
      element: <Companies />,
    },
    {
      path: "/companies/create-company",
      element: <CreateOrUpdateCompany />,
    },
    {
      path: "/companies/update-company/:id",
      element: <CreateOrUpdateCompany />,
    },
    {
      path: "/agent-companies",
      element: <AgentCompanies />,
    },
    {
      path: "/agent-companies/create",
      element: <CreateOrUpdateAgentCompany />,
    },
    {
      path: "/agent-companies/update/:id",
      element: <CreateOrUpdateAgentCompany />,
    },
    {
      path: "/agent-companies/:id",
      element: <AgentCompanyDetails />,
    },
    {
      path: "/roles",
      element: <RolesManagement />,
    },
    {
      path: "/roles/create-role",
      element: <CreateOrUpdateRole />,
    },
    {
      path: "/roles/update-role/:id",
      element: <CreateOrUpdateRole />,
    },
    {
      path: "/roles/role-details/:id",
      element: <RoleDetails />,
    },
    {
      path: "/users",
      element: <UsersManagement />,
    },
    {
      path: "/users/user-details/:id",
      element: <UserDetails />,
    },
    {
      path: "/users/create-user",
      element: <CreateOrUpdateUser />,
    },
    {
      path: "/users/update-user/:id",
      element: <CreateOrUpdateUser />,
    },
    {
      path: "/users/update-user-permissions/:id",
      element: <UpdateUserPermissions />,
    },
    {
      path: "/questions",
      element: <QuestionsManagement />,
    },
    {
      path: "/questions/create-question",
      element: <CreateOrUpdateQuestion />,
    },
    {
      path: "/questions/update-question/:id",
      element: <CreateOrUpdateQuestion />,
    },
    {
      path: "/questions/question-details/:id",
      element: <QuestionDetails />,
    },
    {
      path: "/clients",
      element: <ClientsManagement />,
    },
    {
      path: "/clients/client-details/:id",
      element: <ClientDetails />,
    },
    {
      path: "/patients",
      element: <PatientManagement />,
    },
    {
      path: "/packages",
      element: <Packages />,
    },
    {
      path: "/packages/update/:id",
      element: <CreateOrUpdatePackage />,
    },
    {
      path: "/treatments",
      element: <TreatmentManagement />,
    },
    {
      path: "/treatments-action-needed",
      element: <ActionNeededTreatments />,
    },
    {
      path: "/treatments-archived",
      element: <ArchivedTreatments />,
    },
    {
      path: "/treatments/details/:id",
      element: <TreatmentDetails />,
    },
    {
      path: "/treatments/details/:id/:additionalId",
      element: <TreatmentDetails />,
    },
    {
      path: "/treatments/plan-details/:id",
      element: <PlanDetails />,
    },
    {
      path: "/treatments/plan-details/:id/:additionalId",
      element: <PlanDetails />,
    },
    {
      path: "/treatments/submit-plan/:id",
      element: <SubmitPlan />,
    },
    {
      path: "/treatments/submit-plan/:id/:additionalId",
      element: <SubmitPlan />,
    },
    {
      path: "/treatments-on-going",
      element: <ViewOnGoingTreatments />,
    },

    {
      path: "/case-pricing",
      element: <CasePricing />,
    },
    {
      path: "/case-pricing/create",
      element: <CreateOrUpdateCasePricing />,
    },
    {
      path: "/case-pricing/update/:id",
      element: <CreateOrUpdateCasePricing />,
    },
    {
      path: "/case-treatment-material",
      element: <CaseTreatmentMaterial />,
    },
    {
      path: "/case-treatment-material/create",
      element: <CreateOrUpdateCaseTreatmentMaterial />,
    },
    {
      path: "/case-treatment-material/:id",
      element: <CreateOrUpdateCaseTreatmentMaterial />,
    },
    {
      path: "/treatment-colors",
      element: <TreatmentColors />,
    },
    {
      path: "/treatment-colors/create",
      element: <CreateOrUpdateTreatmentColors />,
    },
    {
      path: "/treatment-colors/:id",
      element: <CreateOrUpdateTreatmentColors />,
    },
    {
      path: "/treatment-types",
      element: <TreatmentTypes />,
    },
    {
      path: "/treatment-types/create",
      element: <CreateOrUpdateTreatmentTypes />,
    },
    {
      path: "/treatment-types/:id",
      element: <CreateOrUpdateTreatmentTypes />,
    },
    {
      path: "/cases",
      element: <CaseManagement />,
    },
    {
      path: "/cases-action-needed",
      element: <ActionNeededCases />,
    },
    {
      path: "/cases-on-going",
      element: <OnGoingCases />,
    },
    {
      path: "/cases/details/:id",
      element: <CaseDetails />,
    },
    {
      path: "/cases/details/:id/:additionalId",
      element: <CaseDetails />,
    },
    {
      path: "/promo-codes",
      element: <PromoCodes />,
    },
    {
      path: "/promo-codes/create",
      element: <CreateOrUpdatePromoCode />,
    },
    {
      path: "/promo-codes/update/:id",
      element: <CreateOrUpdatePromoCode />,
    },
    {
      path: "/my-profile",
      element: <MyProfile />,
    },
    {
      path: "/agent-company-dashboard",
      element: <AgentCompanyDashboard />,
    },
    {
      path: "/cash-payment-report",
      element: <CashPaymentReport />,
    },
    {
      path: "/planner-statistics",
      element: <PlannerStatistics />,
    },
    {
      path: "/fabricator-statistics",
      element: <FabricatorStatistics />,
    },
    {
      path: "/coordinator-statistics",
      element: <CoordinatorStatistics />,
    },
    {
      path: "/agent-company-statistics",
      element: <AgentCompanyStatistics />,
    },
    {
      path: "/price-brackets",
      element: <PriceBracketsList />,
    },
    {
      path: "/price-brackets/create",
      element: <CreateUpdate />,
    },
    {
      path: "/price-brackets/edit/:id",
      element: <CreateUpdate />,
    },
  ],
};

const unAuthorizedStructure = {
  fallbackPath: initialUrl,
  routes: authRouteConfig,
};

const anonymousStructure = {
  routes: errorPagesConfigs.concat([
    {
      path: "/terms-of-service",
      element: <TermsOfService />,
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "*",
      element: <Error404 />,
    },
  ]),
};

export { authorizedStructure, unAuthorizedStructure, anonymousStructure };
